import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "onl4-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Оплата по счету недоступна!", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_find_step = _resolveComponent("find-step")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_check_step = _resolveComponent("check-step")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_wait_payment_dialog = _resolveComponent("wait-payment-dialog")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((_ctx.paymentTypes?.length && _ctx.division && _ctx.APIKey) || _ctx.startLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_stepper, {
            "header-nav": "",
            class: "onl-bill-stepper",
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event)),
            style: _normalizeStyle({ 'background-color': _ctx.bg }),
            animated: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_step, {
                "header-nav": true,
                name: 1,
                title: "Поиск счета",
                icon: "settings",
                done: _ctx.step > 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_find_step)
                ]),
                _: 1
              }, 8, ["done"]),
              _createVNode(_component_q_step, {
                "header-nav": false,
                name: 2,
                title: "Проверка счета",
                icon: "settings",
                done: _ctx.step > 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_check_step)
                ]),
                _: 1
              }, 8, ["done"])
            ]),
            _: 1
          }, 8, ["modelValue", "style"]),
          _createVNode(_component_wait_payment_dialog)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_q_banner, {
            style: {"margin-bottom":"20px"},
            class: "bg-red text-white text-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_4,
                (!_ctx.paymentTypes?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Нет доступных типов оплаты!"))
                  : _createCommentVNode("", true),
                (!_ctx.division)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Не инициализирован window.onlDivision!"))
                  : _createCommentVNode("", true),
                (!_ctx.APIKey)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Не инициализирован window.onlAPIKey!"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])),
    _createVNode(_component_q_inner_loading, { showing: _ctx.startLoading }, null, 8, ["showing"])
  ]))
}